module.exports = __webpack_public_path__ + "static/img/engagement-restore.1ff1c79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/engagement-restore.png
// module id = 45
// module chunks = 0